import { hubApi } from '@infl-ts/util-hub-axios-instance';
import { makeDecodeError } from '@infl-ts/util-make-apollo-decoded';
import { isCancellation } from '@infl-ts/util-query-errors';
import * as DE from '@nll/datum/lib/DatumEither';
import * as E from 'fp-ts/Either';
import { constant, constVoid, pipe } from 'fp-ts/function';
import * as T from 'fp-ts/Task';
import * as TE from 'fp-ts/TaskEither';
export var makeHubApiRequest = function makeHubApiRequest(_ref) {
  var jwt = _ref.jwt,
      currentHubURL = _ref.currentHubURL,
      method = _ref.method,
      url = _ref.url,
      data = _ref.data,
      params = _ref.params,
      cancelToken = _ref.cancelToken,
      outputCodec = _ref.outputCodec,
      onData = _ref.onData;
  void pipe(hubApi({
    jwt: jwt,
    currentHubURL: currentHubURL
  }).request({
    method: method,
    url: url,
    data: data,
    params: params,
    cancelToken: cancelToken
  }), TE.map(function (result) {
    return outputCodec ? pipe(outputCodec.decode(result.data), E.mapLeft(makeDecodeError), constant, DE.fromEither) : DE.success(result.data);
  }), TE.fold(function (err) {
    return isCancellation(err) ? T.fromIO(constVoid) : T.fromIO(function () {
      onData(DE.failure(err));
    });
  }, function (res) {
    return T.fromIO(function () {
      onData(res);
    });
  }))();
};